import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { DocumentLibraryService } from '@dealstack/frontend/shared/dataExchange/services/document-library/document-library.service.ts';
import {
	ClassificationGroupType,
	DealClassifierGroupRes,
} from '@dealstack/shared/lib/generated/index.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { useParams } from 'react-router-dom';
import { defaultToEmptyString } from '@dealstack/shared/lib/format/string.ts';

// Classifiers belong to a deal, so there are none to offer on an organisation route.
export const useClassifierOptions = () => {
	const dealId = defaultToEmptyString(useParams().dealId);

	const { data: classifierData } = useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.DEAL_DEALID_DOCUMENT_LIBRARY_CLASSIFIER_GROUPS_GET, {
				dealId,
			}),
		],
		queryFn: ({ signal }) =>
			DocumentLibraryService.get<DealClassifierGroupRes[]>(
				formatUnicorn(API_PATHS.DEAL_DEALID_DOCUMENT_LIBRARY_CLASSIFIER_GROUPS_GET, {
					dealId,
				}),
				undefined,
				signal
			),
		enabled: !!dealId,
	});

	return useMemo(() => {
		if (!classifierData?.payload) {
			return [];
		}
		return classifierData.payload
			.filter(
				(item: DealClassifierGroupRes) =>
					item.groupType === ClassificationGroupType.COMPLETED_DOCUMENTS
			)
			.map((classifier) => ({
				value: classifier.name,
				label: classifier.name,
			}));
	}, [classifierData]);
};
